<sg-ng-button-social
    class="mr-3 mb-3 d-block"
    label="Continue with {{ socialPlatform | titlecase }}"
    [social]="socialPlatform"
    path="/ng-assets/styleguide/svg/"
    (click)="socialSignIn()"
></sg-ng-button-social>

<mlp-ng-alerts></mlp-ng-alerts>
